// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { safeJsonParse } from "@turnerBlueprint/XDL/Utilities";
import * as React from "react";

export interface MySaleRepStyles {
    container?: InjectableCss;
    title?: TypographyPresentationProps;
    name?: TypographyPresentationProps;
    phoneNum?: LinkPresentationProps;
    email?: LinkPresentationProps;
}

export const mySaleRepStyles: MySaleRepStyles = {};
const styles = mySaleRepStyles;

const MySaleRep = () => {
    const { primarySalesRep } = useAppSelector(state => {
        const session = getSession(state);
        return {
            primarySalesRep: safeJsonParse(session.properties["primarySalesRep"]) || {},
        };
    });
    return (
        <>
            {(primarySalesRep.Name.trim() || primarySalesRep.Email || primarySalesRep.PhoneNumber) && (
                <StyledWrapper {...styles.container}>
                    <Typography {...styles.title}>{translate("My Sales Rep")}</Typography>
                    <Typography {...styles.name}>{primarySalesRep.Name}</Typography>
                    {primarySalesRep.PhoneNumber && (
                        <Link {...styles.phoneNum} href={`tel:${primarySalesRep.PhoneNumber}`}>
                            {primarySalesRep.PhoneNumber}
                        </Link>
                    )}
                    {primarySalesRep.Email && (
                        <Link {...styles.email} href={`mailto:(${primarySalesRep.Email})`}>
                            {primarySalesRep.Email}
                        </Link>
                    )}
                </StyledWrapper>
            )}
        </>
    );
};

const definition: WidgetDefinition = {
    group: "Common",
};

const widgetModule: WidgetModule = {
    component: MySaleRep,
    definition,
};

export default widgetModule;
